import { useMutation } from 'react-query';
import { options as defaultHeaders } from 'lib/config';
import { EXPRESS_API } from 'configs/api/expressApi';

const deleteDrop = async (dropId: string) => {
  const { bearerToken: headers } = defaultHeaders;
  return (
    await EXPRESS_API.delete(`droplr/file/${dropId}`, {
      headers,
    })
  ).data;
};

export const useDeleteDrop = () => {
  return useMutation((dropId: string) => deleteDrop(dropId));
};
